export default {
  priv: 'pr_reference',
  overviewTitle: 'Fabrikanten',
  detailTitle: 'Fabrikant',
  deleteTitle: 'deze fabrikant',
  url: '/references/suppliers',
  apiUrl: '/suppliers/',
  sortBy: ['name_1'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'suppliers',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name_1',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name_1',
      link: '/references/suppliers/{id}',
      width: '25%'
    },
    {
      text: 'Adres',
      value: 'address_1',
      width: '25%'
    },
    {
      text: 'Postcode',
      value: 'pc',
      align: 'center',
      width: '10%'
    },
    {
      text: 'Plaats',
      value: 'city',
      width: '10%'
    },
    {
      text: 'Land',
      value: 'country',
      width: '10%'
    }
  ]
};
